/** Shared authenticated-app shell: navbar, sidebar, and page content outlet. */

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Sidebar from "@/components/Sidebar";
import { usePerformanceMode } from "@/hooks/usePerformanceMode";

export default function Layout(): React.ReactElement {
  usePerformanceMode();
  const { pathname } = useLocation();

  return (
    <div className="flex h-screen flex-col">
      <Navbar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto p-8">
          {/* Keyed on the route so every navigation animates the page in. */}
          <div key={pathname} className="animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
